import React from 'react';
import { useStyletron } from 'baseui';
import { PLACEMENT, StatefulTooltip } from 'baseui/tooltip';
import type { RelationshipRowDescriptorT } from '../../../types/frame-timeline-v4';
import { ChevronSpacer } from './chevron-spacer';
import { getNameStyle } from './styles';
type PropsT = {
  descriptor: RelationshipRowDescriptorT;
};
export const RelationshipRowLabel = ({
  descriptor
}: PropsT) => {
  const [css, theme] = useStyletron();
  return <>
      <ChevronSpacer />
      <StatefulTooltip content={descriptor.name} placement={PLACEMENT.top}>
        <span className={css(getNameStyle(theme, true))}>{descriptor.name}</span>
      </StatefulTooltip>
    </>;
};